import React from 'react';
import { SystemText } from '@salesperformanceint/e4shared';
import { Link } from 'react-router-dom';
import BlobImage from 'components/blobImage';
import Bullet from 'components/prism/bullet';
import ProgressBar from '../progressBar';
import { pathwayStatuses } from 'helpers/pathway';
import PathwaySkills from '../pathwaySkills';

export const Pathway = ({ item, onClick, padBottom, managerView }) => {
    const [showSkills, setShowSkills] = React.useState(false);
    const [showQuickCheck, setShowQuickCheck] = React.useState(false);

    const pathwayHasResults = () => item.learn2Completions?.length || item.quickCheckCompletions?.length;
    const pathwayIncomplete = () => item.progress < 100;
    const pathwayComplete = () => item.status === pathwayStatuses.completed;
    const pathwayCanStartOrResume = () => !item.completed && !managerView;

    const contents = (
        <>
            <div className="prism-banner-float flex flex-center">
                <Bullet type="pathway" />
                <div className="flex-grow text-right"></div>
            </div>
            <div className="prism-banner">
                {item.image ? (
                    <BlobImage src={item.image} folder="pathway_Image" noholder />
                ) : (
                    <img src="/dist/img/defaults/pathway-default.jpg" />
                )}
            </div>
            <div className="prism-content flex flex-column">
                {pathwayIncomplete() && <ProgressBar progress={item.progress} />}
                <h3>{item.name}</h3>
                <div className="flex-grow">{item.description && <p className="truncate-4">{item.description}</p>}</div>
                {pathwayCanStartOrResume() && (
                    <div>
                        <button className="btn btn-primary mb10">
                            {item.progress ? SystemText('Welcome/Pathway/Resume') : SystemText('Welcome/Pathway/Start')}
                        </button>
                    </div>
                )}
                <div className="split-col">
                    <Bullet isDueDate={!managerView} isDate={managerView} value={item.due} />
                    {pathwayComplete() ? (
                        <Bullet isStatus value="completed" />
                    ) : (
                        item.duration > 0 && <Bullet isDuration value={item.duration / 60} />
                    )}
                </div>
                {pathwayHasResults() ? (
                    <div className="split-col">
                        <button
                            id={item.id}
                            className="btn btn-cornered btn-tertiary btn-round"
                            onClick={e => viewResultsClick(e)}
                        >
                            {SystemText('General/ViewResults')}
                        </button>
                    </div>
                ) : null}
            </div>
        </>
    );

    const viewResultsClick = e => {
        // Prevents the pathway from actually being loaded
        e.preventDefault();
        e.stopPropagation();

        setShowSkills(item.learn2Completions);
        setShowQuickCheck(item.quickCheckCompletions);
    };

    // prevent a click in the skills modal from propogating as this causes a navigation event, even when the click is to close
    const skillsModal = (
        <div onClick={e => e.stopPropagation()}>
            <PathwaySkills
                showLearn2={showSkills}
                showQuickCheck={showQuickCheck}
                title={SystemText('General/ReviewCourseModalTitle', item.name)}
                close={() => {
                    setShowSkills(false);
                    setShowQuickCheck(false);
                }}
            />
        </div>
    );

    if (onClick) {
        return (
            <a
                key={`pathway-${item.id}`}
                onClick={onClick}
                className={`prism-content-box anchor-top ${padBottom ? 'mb10' : ''}`}
            >
                {contents}
                {skillsModal}
            </a>
        );
    }

    return (
        <Link
            key={`pathway-${item.id}`}
            to={`/pathway/${item.id}`}
            className={`prism-content-box anchor-top ${padBottom ? 'mb10' : ''}`}
        >
            {contents}
            {skillsModal}
        </Link>
    );
};

export default Pathway;
